export default {
  resetQuery(state, data) {
    state.pageData.current = 1;
    state.searchData = {
      current: 1,
      size: state.pageData.size,
      operatorId: null,
      insureName: "",
      caseNo: "",
      caseType: ""
    };
  }
};
